<div class="container-fluid" style="padding-inline:2rem; overflow-y: auto;">
  <div class=" pdf">
    <div class="col-12 d-flex justify-content-between" style="padding-inline: 10px;">
      <div>
        <select style=" height: 2rem;
            border: 1px solid #dddd;
            min-width: 9rem;
            padding-inline: 6px;
            border-radius: 8px;
            max-width: max-content;" [(ngModel)]="dateFilter" (change)="onDateFilterChange()">
           <option selected value="">All</option>  
          <option  value="this-month">This Month</option>
          <option value="last-month">Last Month</option>
          <option value="this-week">This Week</option>
          <option value="last-week">Last Week</option>
        </select>
      </div>
      <div class="export-pdf" (click)="exportToPdf()">
        <img src="/assets/FinanceIcon/doc.png" width="25" height="25" style="background-color: black;" />
        Export as PDF
      </div>
    </div>
  </div>
  <div class="">
    <div class="col-12" style="padding-inline:5px;">
      <div class="row cardclass">
        <div class="col-3">
          <div class="card" style="width: 100%">
            <div class="card-body">
              <div class="card1">
                <p class="card-title">Total Revenue</p>
                <h5>
                  <img src="/assets/FinanceIcon/dollar.png" />
                </h5>
              </div>

              <h2 class="number"><b>$ {{financialOverview?.totalRevenue || 0 }} </b></h2>

             <p class="graphtext-color" *ngIf="financialOverview">
  <img 
    *ngIf="financialOverview.revenuemonthlyGrowthRate > 0" 
    src="/assets/dashboardIcon/Graph.png" 
    alt="Up" 
  />
  <img 
    *ngIf="financialOverview.revenuemonthlyGrowthRate < 0" 
    src="/assets/dashboardIcon/down.png" 
    alt="Down" 
  />
  <img 
    *ngIf="financialOverview.revenuemonthlyGrowthRate === 0" 
    src="/assets/dashboardIcon/neutral.png" 
    alt="No Change" 
  />

  <span 
    [ngStyle]="{
      color: financialOverview.revenuemonthlyGrowthRate > 0 ? '#17B26A' : 
             financialOverview.revenuemonthlyGrowthRate < 0 ? 'red' : 'gray'
    }"
  >
    {{ financialOverview.revenuemonthlyGrowthRate }}%
  </span>

  <span class="gray-text" style="margin-left: 5px;">than last month</span>
</p>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="card" style="width: 100%">
            <div class="card-body">
              <div class="card1">
                <p class="card-title">Guide Payouts</p>
                <h5>
                   <span class="CommingSoon"> Coming Soon </span>
                 
                </h5>
              </div>

              <h2 class="number fw-bold  text-center text-md-start fs-3 fs-md-2"> ${{financialOverview?.guidePayout || 0}}</h2>


             <p class="graphtext-color" *ngIf="financialOverview">
  <img 
    *ngIf="financialOverview.guidePayoutmonthlyGrowthRate > 0" 
    src="/assets/dashboardIcon/Graph.png" 
    alt="Up" 
  />
  <img 
    *ngIf="financialOverview.guidePayoutmonthlyGrowthRate < 0" 
    src="/assets/dashboardIcon/down.png" 
    alt="Down" 
  />
  <img 
    *ngIf="financialOverview.guidePayoutmonthlyGrowthRate === 0" 
    src="/assets/dashboardIcon/neutral.png" 
    alt="No Change" 
  />

  <span 
    [ngStyle]="{
      color: financialOverview.guidePayoutmonthlyGrowthRate > 0 ? '#17B26A' : 
             financialOverview.guidePayoutmonthlyGrowthRate < 0 ? 'red' : 'gray'
    }"
  >
    {{ financialOverview.guidePayoutmonthlyGrowthRate }}%
  </span>

  <span class="gray-text" style="margin-left: 5px;">than last month</span>
</p>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="card" style="width: 100%">
            <div class="card-body">
              <div class="card1">
                <p class="card-title">Refunds</p>
                <h5>
                   <span class="CommingSoon"> Coming Soon </span>
               
                </h5>
              </div>

              <h2 class="number"><b> ${{financialOverview?.refund || 0}}</b></h2>

             <p class="graphtext-color" *ngIf="financialOverview">
  <img 
    *ngIf="financialOverview.refundmonthlyGrowthRate > 0" 
    src="/assets/dashboardIcon/Graph.png" 
    alt="Up" 
  />
  <img 
    *ngIf="financialOverview.refundmonthlyGrowthRate < 0" 
    src="/assets/dashboardIcon/down.png" 
    alt="Down" 
  />
  <img 
    *ngIf="financialOverview.refundmonthlyGrowthRate === 0" 
    src="/assets/dashboardIcon/neutral.png" 
    alt="No Change" 
  />

  <span 
    [ngStyle]="{
      color: financialOverview.refundmonthlyGrowthRate > 0 ? '#17B26A' : 
             financialOverview.refundmonthlyGrowthRate < 0 ? 'red' : 'gray'
    }"
  >
    {{ financialOverview.refundmonthlyGrowthRate }}%
  </span>

  <span class="gray-text" style="margin-left: 5px;">than last month</span>
</p>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="card" style="width: 100%">
            <div class="card-body">
              <div class="card1">
                <p class="card-title">Net Revenue</p>
                <h5>
                  <img src="/assets/FinanceIcon/dollar.png" />
                </h5>
              </div>

              <h2 class="number"><b> ${{financialOverview?.netRevenue || 0 }} </b></h2>
<p class="graphtext-color" *ngIf="financialOverview">
  <img 
    *ngIf="financialOverview.revenuemonthlyGrowthRate > 0" 
    src="/assets/dashboardIcon/Graph.png" 
    alt="Up" 
  />
  <img 
    *ngIf="financialOverview.revenuemonthlyGrowthRate < 0" 
    src="/assets/dashboardIcon/down.png" 
    alt="Down" 
  />
  <img 
    *ngIf="financialOverview.revenuemonthlyGrowthRate === 0" 
    src="/assets/dashboardIcon/neutral.png" 
    alt="No Change" 
  />

  <span 
    [ngStyle]="{
      color: financialOverview.revenuemonthlyGrowthRate > 0 ? '#17B26A' : 
             financialOverview.revenuemonthlyGrowthRate < 0 ? 'red' : 'gray'
    }"
  >
    {{ financialOverview.revenuemonthlyGrowthRate }}%
  </span>

  <span class="gray-text" style="margin-left: 5px;">than last month</span>
</p>


            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="">
    <div class="col-12">
      <div class="">
        <div class="graphpart">
          <div class="" style="
    padding-inline: 10px;
   ">
            <div class="tab-container">
              <div class="tab-wrappers">
                <input type="radio" name="tab" id="tab1" checked hidden>
                <label for="tab1" class="tab">

                  <span>Total Revenue</span>
                </label>

                <input type="radio" name="tab" id="tab2" hidden>
                <label for="tab2" class="tab">

                  <span>Guide Payouts</span>
                </label>

                <input type="radio" name="tab" id="tab3" hidden>
                <label for="tab3" class="tab">

                  <span>Refunds</span>
                </label>
                <div class="month">
                  |
                  <img src="/assets/FinanceIcon/Greendot.png " style="width: 17px; height: 17px;" />
                  <p> This Month</p>
                  <img src="/assets/FinanceIcon/reddot.png " style="width: 17px; height: 17px;" />
                  <p>Last Month</p>
                </div>

              </div>
             
              <div style="margin: 10px; cursor: pointer;">
                  <span class="CommingSoon"> Coming Soon </span>
                <img *ngIf="showChart" src="/assets/FinanceIcon/Up.svg" (click)="ToggleChart()" />
                <img *ngIf="!showChart" src="/assets/FinanceIcon/down.svg" (click)="ToggleChart()" />
              </div>
            </div>

          </div>
          <div class="col-12">
            <div class="chart-container" [hidden]="!showChart">
              <canvas id="myChart" style="padding-inline: 14px;"></canvas>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-12">
      <div class="row g-0">
        <div class="col-12  main-table">
          <div class="table-bar border-bottom d-flex justify-content-between align-items-center py-2 px-2">
            <h5>Transaction Records</h5>
            <div class="table-controls d-flex align-items-center gap-4">
              <div class="search-wrapper d-flex align-items-center ">
                <img class="table-img" src="/assets/userIcon/searchIcon.png" alt="Search" width="16" height="16" />
                <input class="input-search" type="text" [(ngModel)]="searchText"
              (input)="onSearchChange(searchText)" placeholder="Search by name or email" />
              </div>

              <select style=" height: 2rem;
            border: 1px solid #dddd;
            min-width: 9rem;
            padding-inline: 6px;
            border-radius: 8px;
            max-width: max-content;" [(ngModel)]="selectedTransactionType" (change)="onStatusChange()">
                <option selected value="">All Transactions</option>
                 <option value="Booking">Payments</option>
                <option value="Payout">Payouts</option>
                <option value="Refund">Refunds</option>
              </select>
            </div>
          </div>



          <div class="scrollable"> <table class="table align-middle mb-0 ">
            <thead class="custom-head">
              <tr class="trow">
                <th scope="col" style=""> Transaction ID</th>
                <th scope="col" style="">Date</th>
                <th scope="col" style="">User</th>
                <th scope="col" style="">Description</th>
                <th scope="col" style="">Type</th>
                <th scope="col" style="">Amount</th>
                <th scope="col" style="">Status</th>
              </tr>
            </thead>

               <tr class="No-req" *ngIf="TransactionRecords.length <=0">
                  <td colspan="7" class="text-center py-3 text-muted">No Transactions Records Available.</td>
                </tr>
            <tbody class="" *ngFor="let transaction of TransactionRecords;">
      
             

              
              <tr>
                <td>
                  <span class="bookid">#{{transaction.transactionId}}</span>
                </td>

                <td>
                  <span>{{transaction.transactionDate|customDatePipe}} </span>
                </td>

                <td>
                  <div class="d-flex align-items-center gap-2 guide">
                    <img [src]="transaction.profilePhotoUrl" class="rounded-circle" width="40" height="40" />
                    <div>
                      <div class="fw-semibold">{{transaction.firstName}} {{transaction.lastName}}</div>
                      <div class="text-muted small email">{{transaction.email}}</div>
                    </div>
                  </div>
                </td>

                <td>
                  <p style="font-weight: 400;"> {{transaction.description}}</p>
                </td>

                <td>
                  <span class="payment" *ngIf="transaction.transactionName=='Booking'">Payment</span>
                   <span class="payout" *ngIf="transaction.transactionName=='Payout'">Payout</span>
                    <span *ngIf="transaction.transactionName=='Refund'" class="Refund">Refund</span>

                </td>
                <td class="status-td">
                  <span style=" color:#17B26A" *ngIf="transaction.transactionName=='Booking'">${{transaction.amount}} </span>
                  <span style=" color:#F04438" *ngIf="transaction.transactionName!='Booking'">${{transaction.amount}} </span>
                </td>
                <td class="status" style="width: 11%;">
                  <span class="bookingstatus" *ngIf="transaction.status=='succeeded'">
                    <img src="/assets/bookingIcon/Success.svg" width="15" height="15">
                      Completed
                 </span>
                 <span class="bookingstatuscanceled" *ngIf="transaction.status=='Failed'" ><img src="/assets/bookingIcon/Rejected.svg" width="15" height="15">
                    Failed</span>
                       <span class="bookingstatuspending" *ngIf="transaction.status=='requires_payment_method'" ><img src="/assets/bookingIcon/Pending.svg" width="15" height="15">
                    Pending</span>
                </td>
              </tr>
             
         


            </tbody>
           </table> 
          </div>
         
             <div class="pagenatiom">
        <app-pegination [pageAll]="PageNumber" [totalPages]="TotalTransactionPages" [pageSize]="PageSize"
          (pageChange)="goToPages($event)" (sizeChange)="onSizeChanges($event)">
        </app-pegination>
      </div>
        </div>
      </div>
    </div>

  </div>
</div>
